import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExpressionOperator } from 'src/app/model/search-filters/expression-operator';
import { Filter } from 'src/app/model/search-filters/filter';
import { SearchFilterItem } from 'src/app/model/search-filters/search-filter-item';
import { SearchFilterType } from 'src/app/model/search-filters/search-filter-type';

export type AddItemDialogData = {
  availableFilters: Filter[];
};

@Component({
  selector: 'gymfinder-add-item-dialog',
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.scss'],
  standalone: false,
})
export class AddItemDialogComponent implements OnInit {
  item: SearchFilterItem = {
    type: SearchFilterType.BUTTON,
    childrenLogic: ExpressionOperator.AND,
    peerLogic: ExpressionOperator.AND,
    text: {},
    alwaysActive: false,
    visible: true,
    order: 0,
    filters: [],
  };

  availableFilters: Filter[];

  constructor(
    private dialogRef: MatDialogRef<AddItemDialogData>,
    @Inject(MAT_DIALOG_DATA) private data: AddItemDialogData
  ) {}

  ngOnInit(): void {
    this.availableFilters = this.data.availableFilters;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public addItem() {
    this.dialogRef.close(this.item);
  }
}
